import { getComprobanteFiscalClienteDowload } from "../services/documentosService";
import { getSolicitudFacturasPendientesAll, putDeclinarSolitudFacturaAgente, putValidateSolicitudFactura } from "../services/invoiceService";

const dataInicial = {
    listFacturasPendientes: [],
    pagina: 0,
    registros: 10,
    busqueda: "0",
    total: 0,
    exito: 0,
};

const GET_FACTURACION_PENDIENTES_ALL = "GET_FACTURACION_PENDIENTES_ALL"
const GET_FACTURACION_PENDIENTES_PAGINA = "GET_FACTURACION_PENDIENTES_PAGINA"
const GET_FACTURACION_PENDIENTES_REGISTROS = "GET_FACTURACION_PENDIENTES_REGISTROS"
const GET_FACTURACION_PENDIENTES_BUSQUEDA = "GET_FACTURACION_PENDIENTES_BUSQUEDA"
const CLEAR_FACTURACION_PENDIENTES = "CLEAR_FACTURACION_PENDIENTES"
const GET_FACTURACION_ESTADO_CUENTA_DOWLOAD = "GET_FACTURACION_ESTADO_CUENTA_DOWLOAD"
const PUT_FACTURACION_PENDIENTES_APROVAR = "PUT_FACTURACION_PENDIENTES_APROVAR"
const PUT_FACTURACION_PENDIENTES_DECLINAR = "PUT_FACTURACION_PENDIENTES_DECLINAR"
//* Metodos para el modulo de facturas pendientes
export default function facturasPendientesReducer(state = dataInicial, action) {
    switch (action.type) {
        case PUT_FACTURACION_PENDIENTES_DECLINAR:
            return { ...state, exito: action.payload.exito }
        case PUT_FACTURACION_PENDIENTES_APROVAR:
            return { ...state, exito: action.payload.exito }
        case GET_FACTURACION_ESTADO_CUENTA_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case GET_FACTURACION_PENDIENTES_ALL:
            return { ...state, listFacturasPendientes: action.payload.listFacturasPendientes, total: action.payload.total }
        case GET_FACTURACION_PENDIENTES_PAGINA:
            return { ...state, listFacturasPendientes: action.payload.listFacturasPendientes, pagina: action.payload.pagina, total: action.payload.total }
        case GET_FACTURACION_PENDIENTES_REGISTROS:
            return { ...state, listFacturasPendientes: action.payload.listFacturasPendientes, registros: action.payload.registros, total: action.payload.total }
        case GET_FACTURACION_PENDIENTES_BUSQUEDA:
            return { ...state, listFacturasPendientes: action.payload.listFacturasPendientes, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros }
        case CLEAR_FACTURACION_PENDIENTES:
            return { ...state, listFacturasPendientes: action.payload.array, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
        default:
            return state;
    }
}

export const obtenerFacturasPendientesAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros } = getSate().facturasPendientes
    return await getSolicitudFacturasPendientesAll({ Pagina: pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_PENDIENTES_ALL,
            payload: {
                listFacturasPendientes: Response.Facturas,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturasPendientesPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros } = getSate().facturasPendientes
    return await getSolicitudFacturasPendientesAll({ Pagina: Pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_PENDIENTES_PAGINA,
            payload: {
                listFacturasPendientes: Response.Facturas,
                pagina: Pagina,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturasPendientesRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina } = getSate().facturasPendientes
    return await getSolicitudFacturasPendientesAll({ Referencia: busqueda, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_PENDIENTES_REGISTROS,
            payload: {
                listFacturasPendientes: Response.Facturas,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturasPendientesBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    return await getSolicitudFacturasPendientesAll({ Referencia: Referencia, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_PENDIENTES_BUSQUEDA,
            payload: {
                listFacturasPendientes: Response.Facturas,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerComprobanteFiscalAction = ({ IdFactura }) => async (dispatch, getSate) => {
    return await getComprobanteFiscalClienteDowload({ IdFactura }).then(Response => {
        dispatch({
            type: GET_FACTURACION_ESTADO_CUENTA_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const validarFacturaAction = ({ IdFactura }) => async (dispatch) => {
    return await putValidateSolicitudFactura({ IdFactura }).then(Response => {
        dispatch({
            type: PUT_FACTURACION_PENDIENTES_APROVAR,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const declinarFacturaAction = ({ IdFactura }) => async (dispatch) => {
    return await putDeclinarSolitudFacturaAgente({ IdFactura }).then(Response => {
        dispatch({
            type: PUT_FACTURACION_PENDIENTES_DECLINAR,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
